const PREVIEW_WIDTH = window.innerWidth;

export default (theme) => {
    return {
        grid: { height: "100%" },
        loading: {
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        cameraWrapper: {
            width: "100%",
            height: "100%",
            marginTop: theme.spacing(2),
        },
        videoOverlay: {
            marginTop: theme.spacing(2),
            display: "flex",
            justifyContent: "center",
            position: "relative",
        },
        videoStream: {
            overflow: "hidden",
            borderRadius: "1rem",
            objectFit: "cover",
        },
        overlayImage: {
            position: "absolute",
            left: theme.spacing(2),
            right: 0,
            top: 0,
            bottom: 0,
            borderRadius: "1rem",
            height: `calc(${PREVIEW_WIDTH - 64}px - ${theme.spacing(4)})`,
            height: "100%",
            width: `calc(100% - ${theme.spacing(4)})`,
        },
        wrapper: {
            padding: theme.spacing(2),
        },
        previewWrp: {
            paddingTop: theme.spacing(2),
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            borderTop: `1px solid ${theme.palette.primary.lightBorder}`,
        },
        imagePreview: {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
        },
        preview: {
            backgroundColor: theme.palette.background.darkBackground,
            width: PREVIEW_WIDTH,
            height: PREVIEW_WIDTH,
            objectFit: "cover",
        },
        loadingWrapper: {
            display: "flex",
            justifyContent: "center",
            marginTop: theme.spacing(8),
        },
        centeredGrid: {
            textAlign: "center",
            alignSelf: "center",
        },
        flashIcon: { fontSize: "3rem" },
        fishEyeIcon: { fontSize: "5rem" },
    };
};
